<template>
  <div>
    <div v-if="anyUserOrganizationsAvailable">
      <div v-if="anyOrgProjectsAvailable">
        <br>
        <v-card
          v-for="(item, index) in organizationProjects"
          :key="index"
          small
          color="transparent"
          class="project-card"
          elevation="0"
        >
          <v-row>
            <v-col>
              <div class="container-box">
                <div class="box">
                  <v-card-text>
                    <v-row>
                      <v-col cols="8">
                        <p class="title-text-style">
                          <font class="subheader-style">
                            {{ item.name }}
                          </font>
                        </p>
                      </v-col>
                      <v-col cols="4">
                        <p class="title-text-style d-flex justify-end">
                          <font
                            class="font-style"
                            :color="getColor(item.status)"
                          >
                            {{ item.status | capitalizeFirstLetter }}
                          </font>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col>
                        <div class="d-flex align-center justify-space-between">
                          <p class="title-text-style">
                            <v-icon
                              color="green"
                              size="18"
                            >
                              mdi-calendar-start
                            </v-icon>
                            <font class="value-text-style">
                              {{ item.start_date | formatDate }}
                            </font>
                          </p>
                          <p class="title-text-style">
                            <v-icon
                              color="red"
                              size="18"
                            >
                              mdi-calendar-end
                            </v-icon>
                            <font class="value-text-style">
                              {{ item.end_date | formatDate }}
                            </font>
                          </p>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col class="py-0">
                        <div class="d-flex justify-content-center align-center">
                          <v-progress-linear
                            color="#8abceb"
                            height="10"
                            class="rounded"
                            :value="item.project_progress"
                          />
                          <b class="pa-2 black--text">{{ Math.ceil(item.project_progress) }}%</b>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col>
                        <div class="time-style">
                          <p>
                            <v-btn
                              small
                              elevation="0"
                              color="#64CA7F"
                              outlined
                              class="btn-sm"
                              @click="showAppUserProjectActivity(item)"
                            >
                              Activities
                            </v-btn>
                          </p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div
        v-else
        class="empty-alert-div"
      >
        <v-card
          color="#FFF"
          elevation="0"
        >
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>
            No projects found
          </p>
          <br>
          <br>
        </v-card>
      </div>
    </div>
    <div
      v-else
      class="empty-alert-div"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No Organizations found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <centre-spinner :loading="loading" />
    <check-in-types
      v-if="showCheckInTypes"
      @closed="showCheckInTypes = false"
      @checkin-type-selected="continueCheckInProcess"
    />
    <select-project-gate
      v-if="showProjectGates"
      @closed="showProjectGates = false"
      @project-gate-selected="goToCheckInTypes"
    />
    <app-user-project-activities
      v-if="projectUserActivity"
      :project-id="projectId"
      :org-ext-id="orgExtId"
      :project-name="projectName"
      @closed="projectUserActivity = false"
    />
  </div>
</template>
<script>
import SelectProjectGate from 'src/views/dashboard/Components/dialogComponents/SelectProjectGate';
import CheckInTypes from 'src/views/dashboard/Components/CheckInTypes';
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
import AppUserProjectActivities from '../appuserDialogs/AppUserProjectActivities.vue';
export default {
  name: 'OrganizationProjects',
  components: {
    'centre-spinner': spinner,
    'select-project-gate': SelectProjectGate,
    'check-in-types': CheckInTypes,
    'app-user-project-activities': AppUserProjectActivities,
  },
  filters: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    formatDate (value) {
      return value ? moment(value).format('DD-MM-YYYY') : '';
    },
    statusUpdate (val) {
      if (val === true) {
        return 'Active*';
      }
      return 'Expired';
    },
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('Do MMMM YYYY');
    },
  },
  data: () => ({
    loading: false,
    progress: 0,
    showCheckInTypes: false,
    showProjectGates: false,
    projectUserActivity: false,
    orgExtId: null,
    projectId: null,
    projectName: '',

  }),
  computed: {
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    anyUserOrganizationsAvailable () {
      if (this.userOrganizations.length !== 0) {
        return true;
      }
      return false;
    },
    organizationProjects () {
        return this.$store.getters['projects/getOrganizationProjects'];
    },
    anyOrgProjectsAvailable () {
      if (this.organizationProjects.length !== 0) {
        return true;
      }
      return false;
    },
    selectedOrgProjectGate () {
      return this.$store.getters['projects/getSelectedOrgProjectGate'];
    },
    userCurrentCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    anyCheckInAvailable () {
      if (Object.keys(this.userCurrentCheckInDetails).length !== 0) {
        return true;
      }
      return false;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    this.loading = true;
    await this.getUserOrganizations();
    this.anyUserOrganizationsAvailable && await this.getOrganizationProjects();
  },
  methods: {
    async getUserOrganizations () {
      this.loading = true;
      await this.$store.dispatch('organization/fetchUserOrganizations', {
        params: {
          requestStatus: 'accepted',
        },
      }).then(() => {
        this.getFirstOrganizationProjects();
      }).catch(() => {
        this.loading = false;
      });
    },
    async getOrganizationProjects () {
      this.loading = true;
      await this.$store.dispatch('projects/fetchOrganizationProjects', {
        organizationExtId: this.selectedOrganization.organization.external_id,
      });
      this.loading = false;
    },
    async toCheckInProcess (item) {
        await this.$store.dispatch('organization/selectedOrganization', this.selectedOrganization);
        await this.$store.dispatch('projects/selectedOrgProject', item);
        await this.$store.dispatch('swiftuser/storeCheckInMethodType', {
          type: 'manual-checkin',
        });
        this.showProjectGates = true;
    },
    getColor (val) {
      if (val === 'active') {
        return '#2E7D32';
      }
      return '#C62828';
    },
    goToCheckInTypes () {
     this.showProjectGates = false;
     this.showCheckInTypes = true;
    },
    continueCheckInProcess (type) {
      const siteId = this.selectedOrgProjectGate.id;
      this.$router.push(`check-in/${siteId}/${type}`);
    },
    showAppUserProjectActivity (item) {
      this.orgExtId = this.selectedOrganization.organization.external_id;
      this.projectId = item.id;
      this.projectName = item.name;
      this.projectUserActivity = true;
    },
  },
};
</script>

<style scoped>
.time-style {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
p{
  margin-bottom:0px!important;
}
.time-style .value-text-style{
  font-size:12px;
}
.box{
  /* padding-bottom: 7px; */
  width: 100% !important;
  border-radius: 10px;
  background: #FFF;
}
.theme--dark.v-list{
  background-color: white!important;
}
.theme--dark >>> .v-list-item{
  color:#37474F!important;
}
.text-white{
  color:white;
}
.rounded{
  border-radius: 10px!important;
}
.subheader-style{
  font-size: 14px;
}
.title-text-style {
  font-size: 12px;
}
.value-text-style{
  font-size: 12px;
}
.project-card {
  border-radius: 0px !important;
  padding: 0px !important;
}
.btn-sm {
  height: 20px !important;
  margin-left: 10px;
}
</style>
